import { lazy } from "@bridgesplit/ui";

const LoanDetail = lazy(() => import("./LoanDetail"));

export * from "./actions";
export { LoanDetail };
